import { forEach } from "lodash-es";
import { isExprObject } from '@tencent/data-schema-core/lib/utils/eval';
import { compileInteropableString, splitInteropableString } from './interopableString';
import { toExpression } from './processScriptContent';
/**
 * 检查输入的（对象/数组/字符串/其他...），
 *
 * 如果存在动态的东西，那么就生成一个 JS 表达式（需要自己补 return 才能用那种）
 *
 * 如果不存在动态的东西，就直接返回 null
 *
 * @returns null（表示 value 是纯静态的，无需编译），或者一个表达式（需要自己前面补上 `return` 才能用）
 */
export function compileInteropableValue(value) {
  if (!value) return null;
  if (Array.isArray(value)) {
    const compiled = value.map(item => compileInteropableValue(item));
    if (!compiled.some(x => typeof x === 'string')) return null; // 无需编译，是一个静态数组
    return `[${compiled.map((item, index) => item === null ? JSON.stringify(value[index]) : item)}]`;
  }
  if (isExprObject(value)) return toExpression(value.$expr);
  if (typeof value === 'object') {
    const exprMap = {};
    const keys = Object.keys(value);
    let hasDynamic = false;
    keys.forEach(key => {
      const expr = compileInteropableValue(value[key]);
      if (expr === null) return;
      hasDynamic = true;
      exprMap[key] = expr;
    });
    if (!hasDynamic) return null;
    return `{\n${keys.map(key => {
      const eee = key in exprMap ? exprMap[key] : JSON.stringify(value[key]);
      return `${JSON.stringify(key)}: ${eee}`;
    }).join(',\n')}\n}`;
  }
  if (typeof value === 'string') {
    const splitted = splitInteropableString(value);
    const {
      parts
    } = splitted;
    if (parts.length === 1) return null; // 不需要插值，纯静态字符串
    return compileInteropableString(parts);
  }
  return null;
}
export function separateAndCompileInteropableFields(value, allowInteropFields) {
  const staticValues = {};
  const dynamicExprs = {};
  let isDynamic = false;
  const allowed = allowInteropFields === 'all' ? 'all' : new Set(allowInteropFields);
  forEach({
    ...value
  }, (value, key) => {
    const expr = isExprObject(value) ? toExpression(value.$expr) : (allowed === 'all' || allowed.has(key)) && compileInteropableValue(value);
    if (expr) {
      dynamicExprs[key] = expr;
      isDynamic = true;
      return;
    }
    if (typeof value !== 'undefined') staticValues[key] = value;
  });
  return {
    isDynamic,
    staticValues,
    dynamicExprs
  };
}
//# sourceMappingURL=compileInteropableValue.js.map
